import { API_BASE_URL } from "../../config";

async function fetchGDPData() {
  try {
    const response = await fetch(`${API_BASE_URL}/gdp`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching GDP data:', error);
    return [];
  }
}

async function fetchNortheastGDPData() {
  try {
    const response = await fetch(`${API_BASE_URL}/northeast`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching Northeast GDP data:', error);
    return [];
  }
}

export const gdpData = await fetchGDPData();
export const northeastGDPData = await fetchNortheastGDPData();